import React from 'react';
import { C } from '../../constants';
import useWindowSize from '../../hooks/useWindowSize';
import UploadTab from '../upload/UploadTab';

export default function UploaderPanel({ token, onClose }) {
  const { width } = useWindowSize();
  const isMobile  = width < 650;
  return (
    <div style={{ position:'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.9)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding: isMobile ? '0' : '20px' }}>
      <div style={{ background:C.bg, border: isMobile ? 'none' : `1px solid ${C.border}`, borderRadius: isMobile ? '0' : '20px', width:'100%', maxWidth:'600px', height: isMobile ? '100%' : 'auto', maxHeight: isMobile ? '100%' : '90vh', overflow:'hidden', display:'flex', flexDirection:'column' }}>
        <div style={{ padding: isMobile ? '14px 16px' : '24px 32px', borderBottom:`1px solid ${C.border}`, display:'flex', justifyContent:'space-between', alignItems:'center', flexShrink:0 }}>
          <h2 style={{ fontFamily:'Playfair Display, serif', fontSize: isMobile ? '17px' : '22px', color:C.text }}>Subir contenido</h2>
          <button onClick={onClose} style={{ background:'transparent', border:`1px solid ${C.accentBorder}`, color:C.textMuted, padding:'7px 14px', borderRadius:'8px', cursor:'pointer', fontSize:'13px' }}>✕</button>
        </div>
        <div style={{ padding: isMobile ? '14px' : '24px 32px', overflowY:'auto', flex:1 }}>
          <UploadTab token={token} />
        </div>
      </div>
    </div>
  );
}
